import React from "react";





//2 

function Admin() {
    //3
    return (
        <>
            
            <div className="container">
                <h1>Admin</h1>
                
            </div>
        </>
    )
}

//4

export default Admin;